// viewer 側の signaling URL 解決。.env / VITE_SIGNALING_URL を優先。
// 未設定時は現在のページのオリジンからプロトコルを推測 (本番デプロイ想定)。

const DEFAULT_DEV_WS = "ws://localhost:8787";

export function getSignalingWsBase(): string {
  const fromEnv = import.meta.env.VITE_SIGNALING_URL as string | undefined;
  if (fromEnv) return fromEnv.replace(/\/$/, "");
  return DEFAULT_DEV_WS;
}
